exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".enter-child-ages[data-v-d35ab8f2] .mobile-select-list{margin-bottom:60px}", ""]);

// exports
